import { Global } from '../Global';
import { post } from '../utils/ApiUtil';
import { BuyerInfoDTO } from '../models/Buyer';
import { SellerInfo } from '../models/Seller';

const imQuiet = (logTag: string) => ({ quiet: true, logTag });

const getSellerOpenInfo = async (userIds: string[]): Promise<SellerInfo[]> => {
  if (!userIds.length) {
    return [];
  }
  if (Global.isMockMode()) {
    const mock = Global.getMockData('getSellerInfo') as SellerInfo[] | undefined;
    return mock || [];
  }
  const result = await post<{ userIds: string[] }, SellerInfo[]>(
    '/buyer/getSellerOpenInfo',
    { userIds },
    imQuiet('message:getSellerOpenInfo'),
  );
  if (typeof result === 'string') {
    console.warn('[MessageUserApi] getSellerOpenInfo 失败', { userIds, result });
    return [];
  }
  if (!Array.isArray(result)) {
    return [];
  }
  return result;
};

const getBuyerPublicInfo = async (buyerIds: string[]): Promise<BuyerInfoDTO[]> => {
  if (!buyerIds.length) {
    return [];
  }
  if (Global.isMockMode()) {
    const mock = Global.getMockData('getBuyerInfo') as BuyerInfoDTO[] | undefined;
    return mock || [];
  }
  const result = await post<string[], BuyerInfoDTO[]>(
    '/buyer/getBuyerInfo',
    buyerIds,
    imQuiet('message:getBuyerInfo'),
  );
  if (typeof result === 'string') {
    console.warn('[MessageUserApi] getBuyerInfo 失败', { buyerIds, result });
    return [];
  }
  if (!Array.isArray(result)) {
    return [];
  }
  return result;
};

export const MessageUserApi = {
  getSellerOpenInfo,
  getBuyerPublicInfo,
};
